// Copyright The OpenTelemetry Authors
// SPDX-License-Identifier: Apache-2.0

interface IRequestParams {
  url: string;
  body?: object;
  method?: 'GET' | 'POST' | 'PUT' | 'DELETE';
  queryParams?: Record<string, any>;
  headers?: Record<string, string>;
}

const request = async <T>({
  url = '',
  method = 'GET',
  body,
  queryParams = {},
  headers = {
    'content-type': 'application/json',
  },
}: IRequestParams): Promise<T> => {
  const urlWithQueryParams = `${url}?${new URLSearchParams(queryParams).toString()}`;
  const response = await fetch(urlWithQueryParams, {
    method,
    body: body ? JSON.stringify(body) : undefined,
    headers,
  });

  const responseText = await response.text();
  const responseStatusText = response.statusText && response.statusText.length > 0 ? response.statusText : responseText ?? '';
  const responseUrl = response.url && response.url.length > 0 ? response.url : urlWithQueryParams;

  if (!response.ok) {
      throw new Error("Response not ok. Status code: " + String(response.status) + ". Status text: '" + responseStatusText + "'. Url: " + responseUrl);
  }

  if (!!responseText) return JSON.parse(responseText);

  return undefined as unknown as T;
};

export default request;
